/* eslint-disable @typescript-eslint/no-unused-vars */
import {
  styled,
  TableFooter,
  TableFooterProps,
  Pagination,
  Button,
  Breadcrumbs,
  Typography,
  InputLabel,
  TextField,
  Box,
} from '@mui/material';
import { ChipStyled } from '../../../components/common/Chips/Chips.styled';


export const StyledFooter = styled(TableFooter)<TableFooterProps>(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  width: '100%',
  borderTop: `1px solid ${theme.palette.grey[200]}`,
}));

export const StyledNavButton = styled(Button)(() => ({
  ':disabled': {
    opacity: '0.6',
  },
}));

export const StyledChip = styled(ChipStyled)(({ theme }) => ({
  fontSize: theme.typography.txs.fontSize,
  svg: {
    width: '12px',
    height: '12px',
  },
  '&.MuiChip-colorSuccess': {
    backgroundColor: theme.palette.success[50],
    color: theme.palette.success[700],
    path: {
      stroke: theme.palette.success[700],
    },
  },
  '&.MuiChip-colorWarning': {
    backgroundColor: theme.palette.warning[50],
    color: theme.palette.warning[700],
  },
  '&.MuiChip-colorError': {
    backgroundColor: theme.palette.error[50],
    color: theme.palette.error[700],
    path: {
      stroke: theme.palette.error[700],
    },
  },
}));

export const StyledPagination = styled(Pagination)(({ theme }) => ({
  button: {
    color: theme.palette.grey[500],
    '&.Mui-selected': {
      backgroundColor: theme.palette.primary[50],
    },
    ':hover': {
      backgroundColor: theme.palette.primary[50],
    },
  },
}));


export const StyledBreadcrumbs = styled(Breadcrumbs)(({ theme }) => ({
  fontSize: theme.typography.txs.fontSize,
  fontWeight: '500',
  '.MuiBreadcrumbs-separator': {
    color: theme.palette.grey[300],
    svg: {
      width: '12px',
      height: '12px',
    },
  },
  button: {
    fontSize: theme.typography.txs.fontSize,
    fontWeight: '500',
    color: theme.palette.primary.main,
    boxShadow: 'none',
    padding: '0',
    svg: {
      height: '15px',
      width: '15px',
    },
  },
}));

export const StyledClientInfo = styled(Typography)(({ theme }) => ({
  fontSize: theme.typography.tsm.fontSize,
  fontWeight: '500',
  span: {
    fontWeight: '400',
  },
  '&:not(:last-child)': {
    marginBottom: '16px',
  },
}));


export const StyledLabel = styled(InputLabel)(({ theme }) => ({
  color: theme.palette.grey[700],
  fontSize: theme.typography.tmd.fontSize,
  marginBottom: 8,
}));

export const StyledNameLabel = styled(Box)(({ theme }) => ({
  ':before': {
    outline: 'none',
    border: 'none',
  },
  color: theme.palette.grey[900],
  fontWeight: 600,
  fontSize: theme.typography.tmd.fontSize,
  '-webkit-text-fill-color': theme.palette.grey[900],
}));

export const StyledNameField = styled(TextField)(({ theme }) => ({
  '*': {
    color: theme.palette.grey[900],
    fontWeight: '600',
    fontSize: theme.typography.tmd.fontSize,
    '-webkit-text-fill-color': theme.palette.grey[900],
  },
  '.Mui-disabled': {
    ':before': {
      outline: 'none',
      border: 'none',
    },
    color: theme.palette.grey[900],
    '-webkit-text-fill-color': theme.palette.grey[900],
  },
  width: '100%',
  maxWidth: '400px',
}));


export const DrawContainer = styled(Box)(() => ({
  flex: '0 1 70%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  polygon: {
    fill: 'transparent',
  },
  polyline: {
    fill: 'rgba(186, 73, 73, 0.5)',
    'stroke-dasharray': '0',
    stroke: 'rgba(0,0,0, .3)',
  },
}));

